import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import { removeArrayItem } from '../../utils/arrayModify';

export const consts = createReqConsts('circles', 'memberFamilyCircle', [
  'REMOVE_ITEM',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'member_family_circles',
  type: 'get',
});

const requestReducer = createReqReducer(consts);

const removeItem = (state, { id }) => {
  const list = removeArrayItem(get(state, 'list', []), 'id', id);

  return { ...state, list };
};

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.REMOVE_ITEM:
      return removeItem(state, payload);

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/circles/memberFamilyCircle.js